import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import { ADD_INTENTION } from '../../Utils/constant'
import doc from '../../assets/images/demande.png'
import { store } from "../../services/service"
import { useStoreBatiment } from '../../store/Paramettre/batimentStore'
import { useStoreEquipement } from '../../store/Paramettre/equipementStore'
import { useStoreForfait } from "../../store/Paramettre/forfaitStore"
import { SubmitButton } from "../Widget/SubmitButton"
export const DemandeIntention = ({ handleNext, numero }) => {
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [loadingLocalisation, setLoadingLocalisation] = useState(false);
    const [forfaitId, setForfaitId] = useState()
    const [typeClient, setTypeClient] = useState(null)
    const [choix, setChoix] = useState("")

    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const forfaits = useStoreForfait()
    const batiments = useStoreBatiment()
    const typeEquipements = useStoreEquipement()
    const navigate = useNavigate()

    useEffect(() => {
        if (latitude && longitude) {
            reset()
        }
        typeEquipements.equipement({ page: 0, param: "", size: 10 })
        batiments.batiments({ page: 0, param: "", size: 10 })
    }, [])
    const exit = () => {
        window.history.back()
        localStorage.removeItem('numeroTicket')
    }
    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, statusConfirmation: choix }
        store(ADD_INTENTION, 'application/json', requestData).then((res) => {
            if (res.status === 200) {
                reset()
                setIsSubmit(null)
                toast.success('Intention enregistré')
                console.log(res);
                localStorage.setItem('numeroTicket', res?.data?.eligibilite?.numeroTicket)
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }

    return (
        <>
            {
                isSubmit === null ? (
                    <div className='flex justify-center my-28 w-full'>
                        <div className='text-center'>
                            <img className='mx-auto' src={doc} height={80} width={80} alt="" />
                            <p className='font-light mt-2  text-sm'>Intention d'abonnement enregistrée</p>
                        </div>
                    </div>
                ) :
                    <form onSubmit={handleSubmit(submit)} className="w-full  mx-auto mt-6">
                        <p className='text-red-600 text-sm'>{Object.keys(errors).length !== 0 ? 'Veuillez remplir tous les champs obligatoires.' : ''}</p>
                        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <label className="form-control xl:w-1/2  lg:w-1/2  md:w-1/2  w-full">
                                <div className="label -mb-1">
                                    <span className="label-text font-medium">
                                        N° ticket <span className="text-red-500">*</span>
                                    </span>
                                </div>
                                <input
                                    {...register('numeroTicket', { required: true })}
                                    type="text"
                                    defaultValue={numero}
                                    placeholder="N° de ticket de vérification "
                                    className="input input-bordered w-full h-10 text-sm "
                                />
                            </label>
                        </div>

                        <div className="my-3">
                            <h2 className=" font-medium">Client</h2>
                            <hr />
                        </div>

                        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
                                <div>
                                    <label className="text-sm">Nom et prenoms <span className="text-red-500">*</span></label>
                                    <input
                                        {...register('nomPrenoms', { required: true })}
                                        type="text"
                                        placeholder="Nom & prénoms "
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div className="">
                                    <label className="text-sm">Email</label>
                                    <input
                                        {...register('email')}
                                        type="email"
                                        placeholder="Email"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Numero Client <span className="text-red-500">*</span></label>
                                    <input
                                        {...register('contatct', { required: true })}
                                        type="text"
                                        placeholder="Contact client"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Seconde contact</label>
                                    <input
                                        {...register('secondContact')}
                                        type="text"
                                        placeholder="Second contact client"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Numero avantages <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        {...register('numeroAvantage', { required: true })}
                                        placeholder="Numero pour les avantages"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Type de client <span className="text-red-500">*</span></label>
                                    <select {...register('typeClient', { required: true })} onChange={(e) => setTypeClient(e.target.value)} className="select select-bordered w-full h-10">
                                        <option value={''} selected>
                                            type de client
                                        </option>
                                        <option value='PARTICULIER'>Particulier</option>
                                        <option value='ENTREPRISE'>Entreprise</option>
                                    </select>
                                </div>

                                {
                                    typeClient === "ENTREPRISE" ?
                                        <div>
                                            <label className="text-sm">Nom de l'entreprise <span className="text-red-500">*</span></label>
                                            <input
                                                {...register('nomEntreprise', { required: true })}
                                                type="text"
                                                placeholder="Entreprise ...."
                                                className="input input-bordered w-full h-10 text-sm "
                                            />
                                        </div>
                                        : null
                                }

                                <div>
                                    <label className="text-sm">Type d'équipement <span className="text-red-500">*</span></label>
                                    <select {...register('equipementId', { required: true })} className="select select-bordered w-full h-10"
                                        onChange={(e) => {
                                            forfaits.forfaitByEquipe(e.target.value)
                                        }}>
                                        <option value={''} disabled selected>
                                            type d'équipement
                                        </option>
                                        {
                                            typeEquipements?.data?.equipements?.map((item) => (
                                                <option value={item.id}>{item.designation}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label className="text-sm">Forfait <span className="text-red-500">*</span></label>

                                    <select {...register('forfaitId', { required: true })} onChange={(e) => { setForfaitId(e.target.value) }} className="select select-bordered w-full h-10">
                                        <option value={''} selected>
                                            Choisir un forfait
                                        </option>
                                        {
                                            forfaits?.ListForfait?.map((item) => (
                                                <option value={item?.id}>
                                                    {item?.designation} - {item?.categorie?.replace("_", " ").toLowerCase()}
                                                </option>
                                            ))
                                        }

                                    </select>
                                </div>


                                <div className="my-2">
                                    <label className="text-sm">Type de batiment <span className="text-red-500">*</span></label>
                                    <select {...register('batimentId', { required: true })} className="select select-bordered w-full h-10">
                                        <option value={''} selected>
                                            type de batiment
                                        </option>
                                        {
                                            batiments?.data?.batiments?.map((item) => (
                                                <option value={item.id}>{item.designation}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label className="text-sm">Nom du superviseur <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        {...register('nomSuperviseur', { required: true })}
                                        placeholder="Nom du superviseur"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Contact du superviseur <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        {...register('contactSuperviseur', { required: true })}
                                        placeholder="Contact du superviseur"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                                <div>
                                    <label className="text-sm">Service partner <span className="text-red-500">*</span></label>
                                    <select {...register('servicePartner', { required: true })} onChange={(e) => setTypeClient(e.target.value)} className="select select-bordered w-full h-10">
                                        <option value={''} selected>
                                            Choisir une service
                                        </option>
                                        <option value='OMASCOM MT'>OMASCOM MT</option>
                                        <option value='GND'>GND</option>
                                        <option value='KAIROS'>KAIROS</option>
                                    </select>

                                </div>
                            </label>
                        </div>

                        <div className="my-3">
                            <h2 className=" font-medium">Localisation</h2>
                            <hr />
                        </div>

                        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">

                                <div>
                                    <label className="text-sm">Commune <span className="text-red-500">*</span></label>
                                    <select {...register('commune', { required: true })} onChange={(e) => setTypeClient(e.target.value)} className="select select-bordered w-full h-10">
                                        <option value={''} selected>
                                            Choisir une commune
                                        </option>
                                        <option value='COCODY'>Cocody</option>
                                        <option value='MARCORY'>Marcory</option>
                                        <option value='YOPOUGON'>Yopougon</option>
                                    </select>

                                </div>

                                <div>
                                    <label className="text-sm">Quartier <span className="text-red-500">*</span></label>
                                    <input
                                        {...register('quartier', { required: true })}
                                        type="text"
                                        placeholder="quartier du client"
                                        className="input input-bordered w-full h-10 text-sm "
                                    />
                                </div>

                            </label>
                        </div>

                        <select {...register('statusConfirmation', { required: true })}
                            onChange={(e) => setChoix(e.target.value)}
                            className="mt-2 select select-bordered w-full h-10 max-w-sm"
                        >
                            <option value={''} selected>
                                Confirmez-vous ?
                            </option>
                            <option value="CONFIRMER">Oui</option>
                            <option value="NON_CONFIRMER">Non</option>
                        </select>
                        {
                            isSubmit === null ? null : (
                                <SubmitButton isSubmit={isSubmit} label={"Enregistrer l'intention"} />
                            )
                        }


                    </form>
            }
            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >

                    <Box sx={{ flex: "1 1 auto" }} />
                    <button
                        disabled={isSubmit !== null ? true : false}
                        className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                        onClick={choix === 'NON_CONFIRMER' && isSubmit === null ? exit : handleNext}
                    >
                        {
                            choix === 'NON_CONFIRMER' && isSubmit === null ? 'Quitter' : 'Poursuivre'
                        }
                    </button>
                </div>
            </div>
        </>
    )
}
